const parsedNumbers = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven'];

export const parseNumber = (value: number): string => {
  return parsedNumbers[value] || `${value}`;
};